import React, { useEffect, useState } from "react";
import {
  Drawer,
  Form,
  Input,
  Button,
  Select,
  InputNumber,
  Checkbox,
  TreeSelect,
  message,
  Spin,
  Row,
  Col,
} from "antd";
import { connect } from "react-redux";
import { getAllBrand } from "../../../../actions/Inventory/brandAction";
import { getAllTag } from "../../../../actions/Inventory/tagAction";
import { getAllCategory } from "../../../../actions/categoryAction";
import { getAllContactMerchandiser } from "../../../../actions/contactAction";
import { getOnlyWarehouse } from "../../../../actions/warehouseAction";
import { createSingleProduct, updateSingleProduct } from "../../../../actions/singleProductAction";

const { Option } = Select;

const UpdateProduct = ({
  getAllBrand,
  getAllTag,
  getAllCategory,
  getOnlyWarehouse,
  getAllContactMerchandiser,
  createSingleProduct,
  brandList,
  tagList,
  Warehouse,
  categoryList,
  supplierList,
  setUpdatelist,
  onSuccess, // Add this prop for callback after successful creation
  details,
  updateSingleProduct,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);


  const showDrawer = () => {
    setVisible(true);
    getAllBrand();
    getAllTag();
    getAllCategory();
    getOnlyWarehouse();
    getAllContactMerchandiser();
    form.setFieldsValue(details);
  };

  const onClose = () => {
    form.resetFields();
    setVisible(false);
  };

  // useEffect(() => {
  //   getAllBrand();
  //   getAllTag();
  //   getAllCategory();
  //   getOnlyWarehouse();
  //   getAllContactMerchandiser();
  // }, []);

  useEffect(() => {
    const fetchWarehouse = async () => {
      const warehouses = await getOnlyWarehouse();
      if (warehouses.length > 0) {
        form.setFieldsValue({ Warehouse: warehouses[0].id });
      }
    };
    fetchWarehouse();
  }, [getOnlyWarehouse, form]);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const res = await updateSingleProduct(details.id, values);
      message.success("Product updated successfully!");
      form.resetFields();
      
      // Call the success callback to refresh the table
      if (onSuccess) {
        onSuccess();
      }
      
      // Toggle update list if provided
      if (setUpdatelist) {
        setUpdatelist((prev) => !prev);
      }
      
      onClose();
    } catch (error) {
      message.error("Failed to create product. Try again!");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <a href="#" onClick={showDrawer} style={{ margin: 4 }}>
            Edit
      </a>
      <Drawer
        title="Update Product"
        width={780}
        onClose={onClose}
        visible={visible}
        destroyOnClose
        bodyStyle={{ paddingBottom: 80 }}
      >
        <Spin spinning={loading}>
          <Form 
          layout="vertical"
           form={form}
           initialValues={details}
            onFinish={onFinish}>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="title"
                  label="Product Title"
                  rules={[{ required: true, message: "Please enter product title" }]}
                >
                  <Input placeholder="Enter product name" />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  name="Category"
                  label="Category"
                  rules={[{ required: true, message: "Please select a category" }]}
                >
                  <TreeSelect
                    showSearch
                    placeholder="Please select"
                    treeDefaultExpandAll
                    allowClear
                    treeNodeFilterProp="title"
                    treeData={categoryList}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item name="Brand" label="Brand">
                  <Select showSearch placeholder="Select brand">
                    {brandList.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item name="Tag" label="Tags">
                  <Select mode="multiple" showSearch placeholder="Select tags">
                    {tagList.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="Warehouse"
                  label="Warehouse"
                  rules={[{ required: true, message: "Please select a warehouse" }]}
                >
                  <Select showSearch placeholder="Select warehouse">
                    {Warehouse.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="tags"
                  label="Tags"
                  rules={[{ required: false, message: "Please enter product title" }]}
                >
                  <Input disabled />
                </Form.Item>
              </Col>

              {/* <Col span={12}>
                <Form.Item name="Merchandiser" label="Supplier">
                  <Select showSearch placeholder="Select supplier">
                    {supplierList.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col> */}
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="stock_alart_amount"
                  label="Stock Alert Amount"
                  rules={[{ required: false, message: "Enter stock alert amount" }]}
                >
                  <InputNumber style={{ width: "100%" }} min={0} placeholder="e.g., 10" />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item name="is_active" valuePropName="checked" initialValue={true}>
                  <Checkbox style={{ marginTop: 30 }}>Active Product</Checkbox>
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col span={24}>
                <Form.Item>
                  <Button type="primary" htmlType="submit" block loading={loading}>
                    Update Product
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Spin>
      </Drawer>
    </>
  );
};

const mapStateToProps = (state) => ({
  brandList: state.brand.brandlist || [],
  tagList: state.tag.taglist || [],
  categoryList: state.category.categorylist || [],
  Warehouse: state.warehouse.warehouselist || [],
  supplierList: state.contacts.contactlistsearchresult || [],
});

export default connect(mapStateToProps, {
  getAllBrand,
  getAllTag,
  getAllCategory,
  getOnlyWarehouse,
  getAllContactMerchandiser,
  createSingleProduct,
  updateSingleProduct,
})(UpdateProduct);